/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiServerExceptionResponse,
  CreateMeetingRequest,
  Meeting,
  UpdateFieldsRequest,
  UpdateMeetingRequest,
} from '../models/index';
import {
    ApiServerExceptionResponseFromJSON,
    ApiServerExceptionResponseToJSON,
    CreateMeetingRequestFromJSON,
    CreateMeetingRequestToJSON,
    MeetingFromJSON,
    MeetingToJSON,
    UpdateFieldsRequestFromJSON,
    UpdateFieldsRequestToJSON,
    UpdateMeetingRequestFromJSON,
    UpdateMeetingRequestToJSON,
} from '../models/index';

export interface MeetApiCreateMeetingOperationRequest {
    workspaceId: string;
    domainId: string;
    createMeetingRequest: CreateMeetingRequest;
}

export interface MeetApiDeleteMeetingRequest {
    workspaceId: string;
    domainId: string;
    meetingId: string;
}

export interface MeetApiDisableMeetingRequest {
    workspaceId: string;
    domainId: string;
    meetingId: string;
}

export interface MeetApiEnableMeetingRequest {
    workspaceId: string;
    domainId: string;
    meetingId: string;
}

export interface MeetApiGetAllMeetingsRequest {
    workspaceId: string;
}

export interface MeetApiGetMeetingRequest {
    workspaceId: string;
    domainId: string;
    meetingId: string;
}

export interface MeetApiUpdateMeetingOperationRequest {
    workspaceId: string;
    domainId: string;
    meetingId: string;
    updateMeetingRequest: UpdateMeetingRequest;
}

export interface MeetApiUpdateMeetingFieldsRequest {
    workspaceId: string;
    domainId: string;
    meetingId: string;
    updateFieldsRequest: UpdateFieldsRequest;
}

/**
 * 
 */
export class MeetApi extends runtime.BaseAPI {

    /**
     * Creates a new meeting and returns it.
     * Create a new meeting
     */
    async createMeetingRaw(requestParameters: MeetApiCreateMeetingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Meeting>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling createMeeting().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling createMeeting().'
            );
        }

        if (requestParameters['createMeetingRequest'] == null) {
            throw new runtime.RequiredError(
                'createMeetingRequest',
                'Required parameter "createMeetingRequest" was null or undefined when calling createMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/domain/{domainId}/meeting`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMeetingRequestToJSON(requestParameters['createMeetingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingFromJSON(jsonValue));
    }

    /**
     * Creates a new meeting and returns it.
     * Create a new meeting
     */
    async createMeeting(requestParameters: MeetApiCreateMeetingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Meeting> {
        const response = await this.createMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a specific meeting by its ID.
     * Delete a meeting
     */
    async deleteMeetingRaw(requestParameters: MeetApiDeleteMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling deleteMeeting().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling deleteMeeting().'
            );
        }

        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling deleteMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/domain/{domainId}/meeting/{meetingId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a specific meeting by its ID.
     * Delete a meeting
     */
    async deleteMeeting(requestParameters: MeetApiDeleteMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMeetingRaw(requestParameters, initOverrides);
    }

    /**
     * Disables a meeting, preventing new bookings without deleting it.
     * Disable a meeting
     */
    async disableMeetingRaw(requestParameters: MeetApiDisableMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Meeting>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling disableMeeting().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling disableMeeting().'
            );
        }

        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling disableMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/domain/{domainId}/meeting/{meetingId}/disable`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingFromJSON(jsonValue));
    }

    /**
     * Disables a meeting, preventing new bookings without deleting it.
     * Disable a meeting
     */
    async disableMeeting(requestParameters: MeetApiDisableMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Meeting> {
        const response = await this.disableMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enables a previously disabled meeting, making it available for booking.
     * Enable a meeting
     */
    async enableMeetingRaw(requestParameters: MeetApiEnableMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Meeting>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling enableMeeting().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling enableMeeting().'
            );
        }

        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling enableMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/domain/{domainId}/meeting/{meetingId}/enable`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingFromJSON(jsonValue));
    }

    /**
     * Enables a previously disabled meeting, making it available for booking.
     * Enable a meeting
     */
    async enableMeeting(requestParameters: MeetApiEnableMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Meeting> {
        const response = await this.enableMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of all meetings that the authenticated user has access to.
     * Retrieve all meetings for the current user
     */
    async getAllMeetingsRaw(requestParameters: MeetApiGetAllMeetingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Meeting>>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getAllMeetings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/meetings`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MeetingFromJSON));
    }

    /**
     * Returns a list of all meetings that the authenticated user has access to.
     * Retrieve all meetings for the current user
     */
    async getAllMeetings(requestParameters: MeetApiGetAllMeetingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Meeting>> {
        const response = await this.getAllMeetingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a specific meeting by its ID.
     * Retrieve a specific meeting by ID
     */
    async getMeetingRaw(requestParameters: MeetApiGetMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Meeting>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getMeeting().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling getMeeting().'
            );
        }

        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling getMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/domain/{domainId}/meeting/{meetingId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingFromJSON(jsonValue));
    }

    /**
     * Returns a specific meeting by its ID.
     * Retrieve a specific meeting by ID
     */
    async getMeeting(requestParameters: MeetApiGetMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Meeting> {
        const response = await this.getMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a meeting\'s strategy configuration without changing the strategy type.
     * Update a meeting\'s strategy configuration
     */
    async updateMeetingRaw(requestParameters: MeetApiUpdateMeetingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Meeting>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateMeeting().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling updateMeeting().'
            );
        }

        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling updateMeeting().'
            );
        }

        if (requestParameters['updateMeetingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMeetingRequest',
                'Required parameter "updateMeetingRequest" was null or undefined when calling updateMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/domain/{domainId}/meeting/{meetingId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMeetingRequestToJSON(requestParameters['updateMeetingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingFromJSON(jsonValue));
    }

    /**
     * Updates a meeting\'s strategy configuration without changing the strategy type.
     * Update a meeting\'s strategy configuration
     */
    async updateMeeting(requestParameters: MeetApiUpdateMeetingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Meeting> {
        const response = await this.updateMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replaces the meeting\'s fields list entirely. The order of the provided list is persisted.
     * Replace meeting fields
     */
    async updateMeetingFieldsRaw(requestParameters: MeetApiUpdateMeetingFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Meeting>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateMeetingFields().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling updateMeetingFields().'
            );
        }

        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling updateMeetingFields().'
            );
        }

        if (requestParameters['updateFieldsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFieldsRequest',
                'Required parameter "updateFieldsRequest" was null or undefined when calling updateMeetingFields().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/meet/workspace/{workspaceId}/domain/{domainId}/meeting/{meetingId}/fields`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFieldsRequestToJSON(requestParameters['updateFieldsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingFromJSON(jsonValue));
    }

    /**
     * Replaces the meeting\'s fields list entirely. The order of the provided list is persisted.
     * Replace meeting fields
     */
    async updateMeetingFields(requestParameters: MeetApiUpdateMeetingFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Meeting> {
        const response = await this.updateMeetingFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
